import { useState, useEffect } from 'react';

// PostDeedModal - Dua nach Abschluss einer Tat
const PostDeedModal = ({ 
  show, 
  t,
  userGender = 'male', // Gender für geschlechtsspezifische Texte
  onComplete // Wird aufgerufen wenn Modal geschlossen werden soll
}) => {
  const [showButton, setShowButton] = useState(false);
  const [isClosing, setIsClosing] = useState(false);

  // Helper: Wähle geschlechtsspezifischen Text
  const getGenderedText = (key) => {
    if (userGender === 'female' && t[`${key}Female`]) {
      return t[`${key}Female`];
    }
    return t[key];
  };

  // Button nach 1.5s einblenden
  useEffect(() => {
    if (show) {
      setShowButton(false);
      setIsClosing(false);
      const timer = setTimeout(() => {
        setShowButton(true);
      }, 1500);
      return () => clearTimeout(timer);
    }
  }, [show]);

  // Haptik-Feedback und Auto-Close
  const handleAminClick = () => {
    // Sanfte Vibration (wenn verfügbar)
    if (navigator.vibrate) {
      navigator.vibrate(50); // 50ms sanfte Vibration
    }
    
    setIsClosing(true);
    
    // Nach 1.2s automatisch schließen (zügiger)
    setTimeout(() => {
      onComplete();
    }, 1200);
  };

  if (!show) return null;
  
  return (
    <div className={`post-deed-overlay ${isClosing ? 'closing' : ''}`} data-testid="post-deed-overlay">
      <div className="post-deed-dua-container">
        {/* Überschrift - abgedunkelt */}
        <p className="post-deed-subtitle">
          {getGenderedText('postDeedGift') || "Dass du diese Tat tun konntest, ist ein Geschenk von Allah."}
        </p>
        
        {/* Arabischer Text */}
        <p className="post-deed-arabic">
          اللَّهُمَّ تَقَبَّلْ مِنِّي
        </p>
        
        {/* Deutsche Übersetzung */}
        <p className="post-deed-translation">
          {t.postDeedDua || "O Allah, nimm es von mir an."}
        </p>
        
        {/* Āmīn Button - erscheint nach 1.5s */}
        <button 
          className={`post-deed-amin-btn ${showButton ? 'visible' : ''} ${isClosing ? 'pressed' : ''}`}
          onClick={handleAminClick}
          disabled={!showButton || isClosing}
          data-testid="post-deed-amin"
        >
          Āmīn
        </button>
      </div>
    </div>
  );
};

export default PostDeedModal;
